import { render, staticRenderFns } from "./vsCheckBox.vue?vue&type=template&id=63a26ace&lang=html&"
import script from "./vsCheckBox.vue?vue&type=script&lang=js&"
export * from "./vsCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsCheckBox.vue"
export default component.exports